import React from 'react';
import { Wind } from 'lucide-react';
import { Toggle } from '../UI/Toggle';

interface FanControlCardProps {
  fanState: boolean;
  isConnected: boolean;
  onCommand: (command: 'ON' | 'OFF') => boolean;
}

export const FanControlCard: React.FC<FanControlCardProps> = ({ fanState, isConnected, onCommand }) => {
  const [error, setError] = React.useState<string | null>(null);

  const handleToggle = (checked: boolean) => {
    if (!isConnected) {
      setError('API not connected');
      setTimeout(() => setError(null), 3000);
      return;
    }

    setError(null);
    const success = onCommand(checked ? 'ON' : 'OFF');
    if (!success) {
      setError('Failed to save fan state');
      setTimeout(() => setError(null), 3000);
    }
  };

  return (
    <div
      className="p-6 rounded-3xl"
      style={{
        backgroundColor: 'rgba(30, 30, 35, 0.95)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-green-500/20">
            <Wind size={24} className="text-green-400" />
          </div>
          <div>
            <div className="text-lg font-semibold">Fan Control</div>
            <div className="text-sm text-gray-400">
              {fanState ? 'ON' : 'OFF'}
            </div>
          </div>
        </div>
        <Toggle
          checked={fanState}
          onChange={handleToggle}
          disabled={!isConnected}
        />
      </div>
      {error && (
        <div className="text-xs text-red-400 mt-2">{error}</div>
      )}
      {!isConnected && (
        <div className="text-xs text-yellow-400 mt-2">Disconnected</div>
      )}
    </div>
  );
};

